import {
  ExamLevel,
  HomePageControlIconName,
  HomePageHeaderLinkType,
  HomePageTemplateStatus,
  IHomePageTemplateCtaBottomBlock,
  IHomePageTemplateCtaStat,
  IHomePageTemplateDemoLessonBlock,
  IHomePageTemplateFeature,
  IHomePageTemplateFeaturesBlock,
  IHomePageTemplateHeaderNavLink,
  IHomePageTemplateHeroBlock,
  IHomePageTemplateMarqueeTextAnimationBlock,
  IHomePageTemplatePartnersBlock,
  IHomePageTemplateSubjectsBlock,
  IHomePageTemplateTextStyles,
  IHomePageTemplateTrustPilotBlock,
  IHomePageTemplateVideoBlock,
  TextPropsFontWeight,
} from '../types'
import defaultHeroImg from '@/images/home/hero.png'
import defaultFeaturesImg from '@/images/home/features-block-img.png'
import defaultEngineeringImg from '@/images/home/education.png'
import defaultScienceImg from '@/images/home/science.png'
import defaultTechnologyImg from '@/images/home/technology.png'
import defaultMathematicsImg from '@/images/home/mathematics.png'
import defaultWealdOfKentPartnerImg from '@/images/home/partners/image2.png'
import defaultArtsAndMediaPartnerImg from '@/images/home/partners/image3.png'
import defaultGeorgeGreensPartnerImg from '@/images/home/partners/image4.png'
import defaultMsLogoPartnerImg from '@/images/home/partners/microsoft-logo.png'
import defaultOpenAiLogoPartnerImg from '@/images/home/partners/openAi-logo.png'
import { Options } from 'react-select'
import { startCase } from 'lodash'

export const defaultHomeTemplateHeroBlock: IHomePageTemplateHeroBlock = {
  image: { src: defaultHeroImg.src, file: null },
  heroTitle: {
    title: {
      text: 'The online STEM tuition platform with a',
      styles: {
        color: '#1D2939',
        onHoverColor: '#1D2939',
        fontSize: 50,
        lineHeight: 60,
        fontWeight: TextPropsFontWeight.VeryBold,
        isItalic: false,
      },
    },
    accentText: {
      text: '95% success rate',
      styles: {
        color: '#7064FF',
        onHoverColor: '#7064FF',
        fontSize: 50,
        lineHeight: 60,
        fontWeight: TextPropsFontWeight.VeryBold,
        isItalic: false,
      },
    },
    asterisk: {
      text: '*',
      styles: {
        color: '#374151',
        onHoverColor: '#374151',
        fontSize: 50,
        lineHeight: 60,
        fontWeight: TextPropsFontWeight.Regular,
        isItalic: false,
      },
    },
  },
  subtitle: {
    text: 'We drastically improve our students’ performance with predictive grades, helping them move up in sets, ace exams, and win places at university.',
    styles: {
      color: '#475467', // cgray-600
      onHoverColor: '#475467', // cgray-600
      fontSize: 16,
      lineHeight: 24,
      fontWeight: TextPropsFontWeight.Fattened,
      isItalic: false,
    },
  },
  footnote: {
    text: '*95% of our students achieve grades A to B in their exams.',
    styles: {
      color: '#344054', // cgray-700
      onHoverColor: '#344054', // cgray-700
      fontSize: 12,
      lineHeight: 18,
      fontWeight: TextPropsFontWeight.SemiBold,
      isItalic: false,
    },
  },
  isEnabled: true,
}

export const defaultHomeTemplateMarqueeTextAnimationBlock: IHomePageTemplateMarqueeTextAnimationBlock =
  {
    textParts: [
      ...Object.values(ExamLevel).map((value) => {
        return { value }
      }),
    ],
    textStyles: {
      color: '#000000',
      onHoverColor: '#000000',
      fontSize: 16,
      lineHeight: 24,
      fontWeight: TextPropsFontWeight.Regular,
      isItalic: false,
    },
    isEnabled: true,
  }

export const defaultHomeTemplateVideoBlock: IHomePageTemplateVideoBlock = {
  titlePt1: {
    text: 'What is unique',
    styles: {
      color: '#FFFFFF',
      onHoverColor: '#FFFFFF',
      fontSize: 36,
      lineHeight: 40,
      fontWeight: TextPropsFontWeight.Bold,
      isItalic: false,
    },
  },
  titlePt2: {
    text: 'about ExamSolutions?',
    styles: {
      color: '#FFFFFF',
      onHoverColor: '#FFFFFF',
      fontSize: 36,
      lineHeight: 40,
      fontWeight: TextPropsFontWeight.Bold,
      isItalic: false,
    },
  },
  subtitle: {
    text: 'We are an AI-driven tutoring platform that accelerates your learning sprints.',
    styles: {
      color: '#E0E6FF', // v8-blue/15
      onHoverColor: '#E0E6FF', // v8-blue/15
      fontSize: 18,
      lineHeight: 24,
      fontWeight: TextPropsFontWeight.Regular,
      isItalic: false,
    },
  },
  link: {
    text: 'Sign Up for Free',
    styles: {
      backgroundColor: '#FFFFFF',
      onHoverBackgroundColor: '#E5E7EB', // cgray-50
      borderColor: 'transparent',
      onHoverBorderColor: 'transparent',
      color: '#3157FF', // v8-blue
      onHoverColor: '#3157FF', // v8-blue
      fontSize: 16,
      lineHeight: 24,
      fontWeight: TextPropsFontWeight.SemiBold,
      isItalic: false,
    },
    href: '/register',
    icon: { name: HomePageControlIconName.ArrowRadar },
    openInNewWindow: false,
  },
  videoUrl: 'https://www.youtube.com/embed/88tBBJtrhmU?si=UDmQuNMB1lsxxHsF',
  isEnabled: true,
}

export const defaultHomeTemplateDemoLessonBlock: IHomePageTemplateDemoLessonBlock =
  {
    // headingText: 'Try it Out!',
    headingText: {
      text: 'Try it Out!',
      styles: {
        color: '#7064FF', // v8-violet
        onHoverColor: '#7064FF', // v8-violet
        fontSize: 30,
        lineHeight: 36,
        fontWeight: TextPropsFontWeight.SemiBold,
        isItalic: false,
      },
    },
    isEnabled: true,
  }

export const initialHomePageTemplateFeaturesBlockListItem: IHomePageTemplateFeature =
  {
    icon: { name: HomePageControlIconName.CheckRounded },
    text: {
      text: '',
      styles: {
        color: '#344054', // cgray-700
        onHoverColor: '#344054', // cgray-700
        fontSize: 16,
        lineHeight: 24,
        fontWeight: TextPropsFontWeight.SemiBold,
        isItalic: false,
      },
    },
  }

export const initialFeaturesBlockListItemStyles: IHomePageTemplateTextStyles = {
  color: '#344054', // cgray-700
  onHoverColor: '#344054', // cgray-700
  fontSize: 16,
  lineHeight: 24,
  fontWeight: TextPropsFontWeight.SemiBold,
  isItalic: false,
}

export const defaultHomeTemplateFeaturesBlock: IHomePageTemplateFeaturesBlock =
  {
    image: { src: defaultFeaturesImg.src, file: null },
    title: {
      text: 'Personalized Interactive Courses',
      styles: {
        color: '#475467', // cgray-600
        onHoverColor: '#475467', // cgray-600
        fontSize: 30,
        lineHeight: 36,
        fontWeight: TextPropsFontWeight.Bold,
        isItalic: false,
      },
    },
    description: {
      text: 'Our free self-paced video courses, crafted by our expert team of educators, are designed to help you achieve your academic aspirations. Boost your grades, gain a deeper understanding of class concepts, and get ready for tests with the added advantage of our AI study buddy, "Exams Solutions AI", providing personalized support, instant feedback, and tailored practice opportunities.',
      styles: {
        color: '#344054', // cgray-700
        onHoverColor: '#344054', // cgray-700
        fontSize: 18,
        lineHeight: 28,
        fontWeight: TextPropsFontWeight.Regular,
        isItalic: false,
      },
    },
    featuresTitle: {
      text: 'Features:',
      styles: {
        color: '#7064FF', // v8-violet
        onHoverColor: '#7064FF', // v8-violet
        fontSize: 16,
        lineHeight: 24,
        fontWeight: TextPropsFontWeight.SemiBold,
        isItalic: false,
      },
    },
    features: [
      {
        icon: { name: HomePageControlIconName.CheckRounded },
        text: {
          text: 'Explore a vast library of concise video tutorials',
          styles: {
            color: '#344054', // cgray-700
            onHoverColor: '#344054', // cgray-700
            fontSize: 16,
            lineHeight: 24,
            fontWeight: TextPropsFontWeight.SemiBold,
            isItalic: false,
          },
        },
      },
      {
        icon: { name: HomePageControlIconName.CheckRounded },
        text: {
          text: 'Get instant feedback from our grading AI bot',
          styles: {
            color: '#344054', // cgray-700
            onHoverColor: '#344054', // cgray-700
            fontSize: 16,
            lineHeight: 24,
            fontWeight: TextPropsFontWeight.SemiBold,
            isItalic: false,
          },
        },
      },
      {
        icon: { name: HomePageControlIconName.CheckRounded },
        text: {
          text: 'Monitor progress with real-time analytics',
          styles: {
            color: '#344054', // cgray-700
            onHoverColor: '#344054', // cgray-700
            fontSize: 16,
            lineHeight: 24,
            fontWeight: TextPropsFontWeight.SemiBold,
            isItalic: false,
          },
        },
      },
      {
        icon: { name: HomePageControlIconName.CheckRounded },
        text: {
          text: 'Money Back Guarantee if you do not hit your target grade',
          styles: {
            color: '#344054', // cgray-700
            onHoverColor: '#344054', // cgray-700
            fontSize: 16,
            lineHeight: 24,
            fontWeight: TextPropsFontWeight.SemiBold,
            isItalic: false,
          },
        },
      },
    ],
    link: {
      text: 'Find your Perfect Course',
      styles: {
        backgroundColor: '#7064FF', // v8-violet
        onHoverBackgroundColor: '#FFF7ED',
        borderColor: '#7064FF', // v8-violet
        onHoverBorderColor: '#7064FF', // v8-violet
        color: '#FFFFFF',
        onHoverColor: '#7064FF', // v8-violet
        fontSize: 16,
        lineHeight: 28,
        fontWeight: TextPropsFontWeight.SemiBold,
        isItalic: false,
      },
      href: '/register',
      icon: null,
      openInNewWindow: false,
    },
    isEnabled: true,
  }

export const defaultHomeTemplateSubjectsBlock: IHomePageTemplateSubjectsBlock =
  {
    headerText: {
      text: 'What do we teach',
      styles: {
        color: '#7064FF', // v8-violet
        onHoverColor: '#7064FF', // v8-violet
        fontSize: 16,
        lineHeight: 24,
        fontWeight: TextPropsFontWeight.SemiBold,
        isItalic: false,
      },
    },
    title: {
      text: 'We specialize in STEM subjects',
      styles: {
        color: '#344054', // cgray-700
        onHoverColor: '#344054', // cgray-700
        fontSize: 36,
        lineHeight: 44,
        fontWeight: TextPropsFontWeight.SemiBold,
        isItalic: false,
      },
    },
    description: {
      text: 'We provide tuition for STEM subjects at all levels. From the Primary level to the University level, we cover all aspects of your curriculum.',
      styles: {
        color: '#344054', // cgray-700
        onHoverColor: '#344054', // cgray-700
        fontSize: 20,
        lineHeight: 30,
        fontWeight: TextPropsFontWeight.Regular,
        isItalic: false,
      },
    },
    animatedElements: [
      {
        icon: { name: HomePageControlIconName.Engineering },
        title: {
          text: 'Engineering',
          styles: {
            color: '#344054', // cgray-700
            onHoverColor: '#344054', // cgray-700
            fontSize: 20,
            lineHeight: 30,
            fontWeight: TextPropsFontWeight.SemiBold,
            isItalic: false,
          },
        },
        description: {
          text: 'We work to build each student’s confidence and give them the courage to ask questions in class',
          styles: {
            color: '#344054', // cgray-700
            onHoverColor: '#344054', // cgray-700
            fontSize: 16,
            lineHeight: 24,
            fontWeight: TextPropsFontWeight.Fattened,
            isItalic: false,
          },
        },
        image: { src: defaultEngineeringImg.src, file: null },
      },
      {
        icon: { name: HomePageControlIconName.Mathematics },
        title: {
          text: 'Mathematics',
          styles: {
            color: '#344054', // cgray-700
            onHoverColor: '#344054', // cgray-700
            fontSize: 20,
            lineHeight: 30,
            fontWeight: TextPropsFontWeight.SemiBold,
            isItalic: false,
          },
        },
        description: {
          text: 'We work to build each student’s confidence and give them the courage to ask questions in class',
          styles: {
            color: '#344054', // cgray-700
            onHoverColor: '#344054', // cgray-700
            fontSize: 16,
            lineHeight: 24,
            fontWeight: TextPropsFontWeight.Fattened,
            isItalic: false,
          },
        },
        image: { src: defaultMathematicsImg.src, file: null },
      },
      {
        icon: { name: HomePageControlIconName.Science },
        title: {
          text: 'Science',
          styles: {
            color: '#344054', // cgray-700
            onHoverColor: '#344054', // cgray-700
            fontSize: 20,
            lineHeight: 30,
            fontWeight: TextPropsFontWeight.SemiBold,
            isItalic: false,
          },
        },
        description: {
          text: 'We work to build each student’s confidence and give them the courage to ask questions in class',
          styles: {
            color: '#344054', // cgray-700
            onHoverColor: '#344054', // cgray-700
            fontSize: 16,
            lineHeight: 24,
            fontWeight: TextPropsFontWeight.Fattened,
            isItalic: false,
          },
        },
        image: { src: defaultScienceImg.src, file: null },
      },
      {
        icon: { name: HomePageControlIconName.Technology },
        title: {
          text: 'Technology',
          styles: {
            color: '#344054', // cgray-700
            onHoverColor: '#344054', // cgray-700
            fontSize: 20,
            lineHeight: 30,
            fontWeight: TextPropsFontWeight.SemiBold,
            isItalic: false,
          },
        },
        description: {
          text: 'We work to build each student’s confidence and give them the courage to ask questions in class',
          styles: {
            color: '#344054', // cgray-700
            onHoverColor: '#344054', // cgray-700
            fontSize: 16,
            lineHeight: 24,
            fontWeight: TextPropsFontWeight.Fattened,
            isItalic: false,
          },
        },
        image: { src: defaultTechnologyImg.src, file: null },
      },
    ],
    isEnabled: true,
  }

export const defaultHomeTemplatePartnersBlock: IHomePageTemplatePartnersBlock =
  {
    headerText: {
      text: 'Our Partner',
      styles: {
        color: '#7064FF', // v8-violet
        onHoverColor: '#7064FF', // v8-violet
        fontSize: 18,
        lineHeight: 24,
        fontWeight: TextPropsFontWeight.SemiBold,
        isItalic: false,
      },
    },
    title: {
      text: 'Trusted by Leading Institutions',
      styles: {
        color: '#4B5563', // gray-600
        onHoverColor: '#4B5563', // gray-600
        fontSize: 30,
        lineHeight: 36,
        fontWeight: TextPropsFontWeight.SemiBold,
        isItalic: false,
      },
    },
    subtitle: {
      text: 'Discover esteemed partner organizations that amplify our 95% success rate*, uniting excellence in education for a brighter future.',
      styles: {
        color: '#4B5563', // gray-600
        onHoverColor: '#4B5563', // gray-600
        fontSize: 16,
        lineHeight: 28,
        fontWeight: TextPropsFontWeight.Regular,
        isItalic: false,
      },
    },
    partners: [
      { image: { src: defaultMsLogoPartnerImg.src, file: null } },
      { image: { src: defaultWealdOfKentPartnerImg.src, file: null } },
      { image: { src: defaultArtsAndMediaPartnerImg.src, file: null } },
      { image: { src: defaultGeorgeGreensPartnerImg.src, file: null } },
      { image: { src: defaultOpenAiLogoPartnerImg.src, file: null } },
    ],
    isEnabled: true,
  }

export const defaultHomeTemplateTrustPilotBlock: IHomePageTemplateTrustPilotBlock =
  {
    text: {
      text: 'Discover customer experiences with ExamSolutions',
      styles: {
        color: '#98A2B3', // cgray-400
        onHoverColor: '#98A2B3', // cgray-400
        fontSize: 20,
        lineHeight: 28,
        fontWeight: TextPropsFontWeight.Regular,
        isItalic: false,
      },
    },
    link: {
      text: 'Leave us a Review!',
      styles: {
        backgroundColor: '#FFFFFF',
        onHoverBackgroundColor: '#60A5FA', // bg-blue-400
        borderColor: 'none',
        onHoverBorderColor: 'none',
        color: '#000000', // v8-blue
        onHoverColor: '#FFFFFF', // v8-blue
        fontSize: 16,
        lineHeight: 24,
        fontWeight: TextPropsFontWeight.Fattened,
        isItalic: false,
      },
      href: 'https://uk.trustpilot.com/review/examsolutions.net',
      icon: null,
      openInNewWindow: true,
    },
    reviews: [
      {
        title: {
          text: 'I found ExamSolutions to be exceptionally convenient',
          styles: {
            color: '#000000', // cgray-400
            onHoverColor: '#000000', // cgray-400
            fontSize: 20,
            lineHeight: 28,
            fontWeight: TextPropsFontWeight.Bold,
            isItalic: false,
          },
        },
        description: {
          text: 'I found ExamSolutions to be exceptionally convenient when it comes to explaining the core principles of mathematics. The site made it easy for to properly find the topics I’m looking for and I appreciated how everything was properly broken down so that it would make the materials easier to comprehend.',
          styles: {
            color: '#000000', // cgray-400
            onHoverColor: '#000000', // cgray-400
            fontSize: 16,
            lineHeight: 24,
            fontWeight: TextPropsFontWeight.Fattened,
            isItalic: false,
          },
        },

        star: 5,
        author: {
          text: 'Sambath Ken',
          styles: {
            color: '#000000', // cgray-400
            onHoverColor: '#000000', // cgray-400
            fontSize: 16,
            lineHeight: 24,
            fontWeight: TextPropsFontWeight.Bold,
            isItalic: false,
          },
        },
      },
      {
        title: {
          text: 'Use examsolutions if you want to succeed in GCSE or A-level Maths',
          styles: {
            color: '#000000', // cgray-400
            onHoverColor: '#000000', // cgray-400
            fontSize: 20,
            lineHeight: 28,
            fontWeight: TextPropsFontWeight.Bold,
            isItalic: false,
          },
        },
        description: {
          text: "Examsolutions.net is an incredible resource for everyone doing a Maths GCSE or A-level materials- you'll find step-by-step tutorials on every topic and step-by-step breakdowns of exam questions too!",
          styles: {
            color: '#000000', // cgray-400
            onHoverColor: '#000000', // cgray-400
            fontSize: 16,
            lineHeight: 24,
            fontWeight: TextPropsFontWeight.Fattened,
            isItalic: false,
          },
        },

        star: 5,
        author: {
          text: 'Nicole Varghese',
          styles: {
            color: '#000000', // cgray-400
            onHoverColor: '#000000', // cgray-400
            fontSize: 16,
            lineHeight: 24,
            fontWeight: TextPropsFontWeight.Bold,
            isItalic: false,
          },
        },
      },
      {
        title: {
          text: 'Got through A level maths by watching these videos!',
          styles: {
            color: '#000000', // cgray-400
            onHoverColor: '#000000', // cgray-400
            fontSize: 20,
            lineHeight: 28,
            fontWeight: TextPropsFontWeight.Bold,
            isItalic: false,
          },
        },
        description: {
          text: "Got through A level maths by watching these videos! Amazing quality and best of all, it was free! Made a donation when I started working and received an email in thanks. Didn't need a tutor after all!",
          styles: {
            color: '#000000', // cgray-400
            onHoverColor: '#000000', // cgray-400
            fontSize: 16,
            lineHeight: 24,
            fontWeight: TextPropsFontWeight.Fattened,
            isItalic: false,
          },
        },

        star: 5,
        author: {
          text: 'Alice Summers',
          styles: {
            color: '#000000', // cgray-400
            onHoverColor: '#000000', // cgray-400
            fontSize: 16,
            lineHeight: 24,
            fontWeight: TextPropsFontWeight.Bold,
            isItalic: false,
          },
        },
      },
      {
        title: {
          text: 'Lifesaver!',
          styles: {
            color: '#000000', // cgray-400
            onHoverColor: '#000000', // cgray-400
            fontSize: 20,
            lineHeight: 28,
            fontWeight: TextPropsFontWeight.Bold,
            isItalic: false,
          },
        },
        description: {
          text: 'ExamSolutions was a life saver for both A level & GCSE mathematics especially that I had moved from a different curriculum in year 11. Thanks so much Stuart!',
          styles: {
            color: '#000000', // cgray-400
            onHoverColor: '#000000', // cgray-400
            fontSize: 16,
            lineHeight: 24,
            fontWeight: TextPropsFontWeight.Fattened,
            isItalic: false,
          },
        },

        star: 5,
        author: {
          text: 'Fatima Akbarpoor',
          styles: {
            color: '#000000', // cgray-400
            onHoverColor: '#000000', // cgray-400
            fontSize: 16,
            lineHeight: 24,
            fontWeight: TextPropsFontWeight.Bold,
            isItalic: false,
          },
        },
      },
    ],
    isEnabled: true,
  }

export const initialHomePageTemplateCtaBottomBlockListItem: IHomePageTemplateCtaStat =
  {
    value: {
      text: '',
      styles: {
        color: '#FFFFFF',
        onHoverColor: '#FFFFFF',
        fontSize: 36,
        lineHeight: 40,
        fontWeight: TextPropsFontWeight.Bold,
        isItalic: false,
      },
    },
    category: {
      text: '',
      styles: {
        color: '#FFFFFF',
        onHoverColor: '#FFFFFF',
        fontSize: 36,
        lineHeight: 40,
        fontWeight: TextPropsFontWeight.Regular,
        isItalic: false,
      },
    },
  }

export const initialCtaBottomBlockListItemValueStyles: IHomePageTemplateTextStyles =
  {
    color: '#FFFFFF',
    onHoverColor: '#FFFFFF',
    fontSize: 36,
    lineHeight: 40,
    fontWeight: TextPropsFontWeight.Bold,
    isItalic: false,
  }

export const initialCtaBottomBlockListItemCategoryStyles: IHomePageTemplateTextStyles =
  {
    color: '#FFFFFF',
    onHoverColor: '#FFFFFF',
    fontSize: 36,
    lineHeight: 40,
    fontWeight: TextPropsFontWeight.Regular,
    isItalic: false,
  }

export const defaultHomeTemplateCtaBottomBlock: IHomePageTemplateCtaBottomBlock =
  {
    title: {
      text: 'Start Learning with the Best Platform',
      styles: {
        color: '#FFFFFF',
        onHoverColor: '#FFFFFF',
        fontSize: 36,
        lineHeight: 40,
        fontWeight: TextPropsFontWeight.Bold,
        isItalic: false,
      },
    },
    subtitle: {
      text: 'Join over 25,000 students already growing with ExamSolutions.',
      styles: {
        color: '#E0E6FF', // v8-blue/15
        onHoverColor: '#E0E6FF', // v8-blue/15
        fontSize: 18,
        lineHeight: 24,
        fontWeight: TextPropsFontWeight.Regular,
        isItalic: false,
      },
    },
    statistics: [
      {
        value: {
          text: '25K+',
          styles: {
            color: '#FFFFFF',
            onHoverColor: '#FFFFFF',
            fontSize: 36,
            lineHeight: 40,
            fontWeight: TextPropsFontWeight.Bold,
            isItalic: false,
          },
        },
        category: {
          text: 'Learners',
          styles: {
            color: '#FFFFFF',
            onHoverColor: '#FFFFFF',
            fontSize: 36,
            lineHeight: 40,
            fontWeight: TextPropsFontWeight.Regular,
            isItalic: false,
          },
        },
      },
      {
        value: {
          text: '11K+',
          styles: {
            color: '#FFFFFF',
            onHoverColor: '#FFFFFF',
            fontSize: 36,
            lineHeight: 40,
            fontWeight: TextPropsFontWeight.Bold,
            isItalic: false,
          },
        },
        category: {
          text: 'Lessons Available',
          styles: {
            color: '#FFFFFF',
            onHoverColor: '#FFFFFF',
            fontSize: 36,
            lineHeight: 40,
            fontWeight: TextPropsFontWeight.Regular,
            isItalic: false,
          },
        },
      },
      {
        value: {
          text: '4K+',
          styles: {
            color: '#FFFFFF',
            onHoverColor: '#FFFFFF',
            fontSize: 36,
            lineHeight: 40,
            fontWeight: TextPropsFontWeight.Bold,
            isItalic: false,
          },
        },
        category: {
          text: 'Video tutorials',
          styles: {
            color: '#FFFFFF',
            onHoverColor: '#FFFFFF',
            fontSize: 36,
            lineHeight: 40,
            fontWeight: TextPropsFontWeight.Regular,
            isItalic: false,
          },
        },
      },
    ],
    link: {
      text: 'Sign Up for Free',
      styles: {
        backgroundColor: '#FFFFFF',
        onHoverBackgroundColor: '#E5E7EB', // cgray-50
        borderColor: 'transparent',
        onHoverBorderColor: 'transparent',
        color: '#444CE7', // v8-blue
        onHoverColor: '#EEF2FF', // v8-blue/5
        fontSize: 16,
        lineHeight: 24,
        fontWeight: TextPropsFontWeight.SemiBold,
        isItalic: false,
      },
      href: '/register',
      icon: null,
      openInNewWindow: false,
    },
    isEnabled: true,
  }

export const initialHeaderNavLinkCourses: IHomePageTemplateHeaderNavLink = {
  href: '/courses',
  title: 'Courses',
  type: HomePageHeaderLinkType.Courses,
}

export const initialHeaderNavLinkPapers: IHomePageTemplateHeaderNavLink = {
  href: '/papers',
  title: 'Papers',
  type: HomePageHeaderLinkType.Papers,
}

export const initialHeaderNavLinkExamSphere: IHomePageTemplateHeaderNavLink = {
  href: '/exam-sphere',
  title: 'Exam Sphere',
  type: HomePageHeaderLinkType.ExamSphere,
}

export const initialHeaderNavLinkPricing: IHomePageTemplateHeaderNavLink = {
  href: '/pricing',
  title: 'Pricing',
  type: HomePageHeaderLinkType.Pricing,
}

export const defaultHomePageTemplateHeaderNavLinks: IHomePageTemplateHeaderNavLink[] =
  [
    initialHeaderNavLinkCourses,
    initialHeaderNavLinkPapers,
    initialHeaderNavLinkPricing,
    initialHeaderNavLinkExamSphere,
  ]

export const homepageTemplateStatusColor: {
  [key in HomePageTemplateStatus]: string
} = {
  [HomePageTemplateStatus.Active]: 'bg-v8-blue',
  [HomePageTemplateStatus.InActive]: 'bg-v8-violet',
}

export const textPropsFontWeightOptions: Options<{
  label: string
  value: TextPropsFontWeight
}> = Object.keys(TextPropsFontWeight).map((p) => ({
  label: startCase(p),
  value: TextPropsFontWeight[p],
}))

export const linkPropsIconOptions: Options<{
  label: string
  value: HomePageControlIconName
}> = Object.keys(HomePageControlIconName).map((p) => ({
  label: startCase(p),
  value: HomePageControlIconName[p],
}))
